import * as React from 'react'
import MUIListItemIcon from '@mui/material/ListItemIcon'

const ListItemIcon = (props) => <MUIListItemIcon {...props} />

export default ListItemIcon
